import {FiltersType, GridSessionType} from 'redux/databases/state'
import {isUuid} from './stringUtility'
import {
  DatabaseMetadata,
  DatabaseMetadataFilterInput,
  ListStringOperationFilterInput,
  StringOperationFilterInput,
} from 'graphql-api'
import {DatabaseOptionType} from 'redux/jobRequests/state'

export const normalizeFilters = (filters: FiltersType) => {
  const {searchQuery} = filters

  const searchOrFilters: DatabaseMetadataFilterInput[] = []

  if (searchQuery.length) {
    searchOrFilters.push({
      raveUrl: {contains: searchQuery} as StringOperationFilterInput,
    })
    searchOrFilters.push({
      databaseVersion: {contains: searchQuery} as StringOperationFilterInput,
    })
    searchOrFilters.push({
      appVersion: {contains: searchQuery} as StringOperationFilterInput,
    })

    if (isUuid(searchQuery)) {
      searchOrFilters.push({
        databaseId: {eq: searchQuery} as StringOperationFilterInput,
      })

      searchOrFilters.push({
        studyGroupUuids: {
          some: {
            in: [searchQuery],
          },
        } as ListStringOperationFilterInput,
      })

      searchOrFilters.push({
        studyUuids: {
          some: {
            in: [searchQuery],
          },
        } as ListStringOperationFilterInput,
      })
    }
  }

  const where: DatabaseMetadataFilterInput = searchOrFilters.length
    ? {or: searchOrFilters}
    : {}

  return where
}

export const normalizeForApi = (gridSession: GridSessionType) => {
  const {
    filters: filters,
  } = gridSession

  const filtersParam = normalizeFilters(filters)

  return {
    filters: filtersParam,
  }
}

export const normalizeDatabaseOptions = (databaseOptions: DatabaseMetadata[] | undefined) => {
  if(!databaseOptions) return [] as DatabaseOptionType[]

  return databaseOptions
    .map(option => ({
      databaseId: option.databaseId,
      raveUrl: option.raveUrl,
      hostname: option.hostname,
    }))
}
